import { render } from "./ImagesCard.vue?vue&type=template&id=49a8e7d7"
import script from "./ImagesCard.vue?vue&type=script&lang=js"
export * from "./ImagesCard.vue?vue&type=script&lang=js"

import "./ImagesCard.vue?vue&type=style&index=0&id=49a8e7d7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__